module.exports = __webpack_public_path__ + "img/C05TechScorpioChampion_ua.45768322.webp";